export const NodeEnv = {
    prod: 'prod',
    dev: 'dev',
    stage: 'stage',
};
//# sourceMappingURL=nodeEnv.js.map